import React, { useContext, useEffect, useRef, useState } from "react";
import { FormioProvider } from "../../context/FormioContext";
// import { Form } from "../../OurForms/Form";
import { useLocation } from "react-router-dom";
import { BreadcrumbsContext } from "../../context/BcrumbsContextProvider";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { NewForm } from "../../OurForms/NewForm";
import { useSelector } from "react-redux";
// import { fetchEquipmentApi } from "../../Apis/Inspection/InspectionApis";
import NewNozzle from "../../components/MyInspections/NewNozzle";
import Loader from "../../components/Loader/Loader";
import axiosInstance from "../../utils/AxiosInstance";
// import ReactDOM from "react-dom";
function MyInspectionForm() {
  const location = useLocation();
  const formInstance = useRef(null);
  const querydata = location.state?.data;
  let submission = location.state?.submission;
  const eqData = location.state?.eqData;
  const rerender = location?.state?.rerender;
  const { UserRolesData } = useSelector((state) => state?.Roles);
  const navigate = useNavigate();
  const [disableCompponents, setdisableCompponents] = useState(null);
  const { setBreadcrumbsItems } = useContext(BreadcrumbsContext);
  // const [newNozzle, setNewNozzle] = useState("");
  // const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log("this is query data", querydata, eqData, submission);
  const [selectedTab, setSelectedTab] = useState(0);

  const getDefaultIndex = () => {
    const index = querydata?.AllStages
      ?.sort((a, b) => a.stageLevel - b.stageLevel).findIndex(
        (stage) => stage?.form?.title === querydata?.form?.title
      );
    return index >= 0 ? index : 0;
  };

  useEffect(() => {
    setSelectedTab(getDefaultIndex());
  }, [querydata]);
  const newNozzleRef = useRef(null);
  useEffect(() => {
    if (rerender) {
      // Reload page
      window.location.reload();
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, rerender: false },
      });
    }
  }, [rerender, navigate, location]);
  const handleBreadcrumbs = () => {
    setBreadcrumbsItems([
      {
        id: 1,
        url: "/my-package/pending",
        name: "My Packages",
      },
      {
        id: 2,
        url: "/my-package/form",
        name: "Form",
      },
    ]);
  };
  const toCamelCase = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, "");
  };
  useEffect(() => {
    if (UserRolesData) {

      const roleKeys = [
        "qcInspector",
        "processEngineer",
        "operationalManager",
        "executiveJobSupervisor",
        "qaInspector",
      ];
      const roleArr = UserRolesData?.role?.map((role) => {
        let camelRole = toCamelCase(role.roleName);

        // Handle special case for qCInspector
        if (camelRole === "qCInspector") {
          camelRole = "qcInspector";
        } else if (camelRole === "qAInspector") {
          camelRole = "qaInspector";
        } else if (camelRole === "executive/JobSupervisor") {
          camelRole = "executiveJobSupervisor";
        }

        return camelRole;
      });

      let obj = {};

      // Create the object with key-value pairs only for matching roles
      roleKeys.forEach((key) => {

        if (!roleArr?.includes(key)) {
          obj[key] = true;
          obj[`${key}1`] = true;
          obj[`${key}2`] = true;
          obj[`${key}3`] = true;
          obj[`${key}4`] = true;
          obj[`${key}5`] = true;
          obj[`${key}6`] = true;
          obj[`${key}7`] = true;
          obj[`${key}8`] = true;
          obj[`${key}9`] = true;
        }
      });

      if (Object.keys(obj).length === 0) {
        setdisableCompponents(null); // Set null if obj is empty
      } else {
        setdisableCompponents({
          ...obj,
        }); // Set the object if it contains any key-value pairs
      }
    }
  }, [UserRolesData]);

  useEffect(() => {
    handleBreadcrumbs();
    return () => {
      setBreadcrumbsItems([]);
    };
  }, [setBreadcrumbsItems]);

  const handleEquipmentChange = async ({ changed, data }, modified, formInstance) => {
    console.log("this is data", modified, data, changed);

    if (data.equipmentNumber === querydata?.equipmentNumbers) {
      //     const response = await fetchEquipmentApi(
      //       data.equipmentNumber,
      //       querydata.jobSiteId
      //     );

      if (eqData) {
        const equipmentData =
          eqData?.equipmentWorking?.length > 0
            ? eqData?.equipmentWorking?.[0]
            : eqData?.componentWorking?.[0];

        const componentData = eqData?.componentWorking || [];
        const equipmentCutData = eqData?.equipmentCuts || [];
        const existingKeys = Object.keys(formInstance.current.submission.data);

        const filteredData = Object.fromEntries(
          Object.entries(equipmentData).filter(([key]) =>
            existingKeys.includes(key)
          )
        );

        // Start building new form data
        let newFormData = {
          ...formInstance.current.submission.data,
          ...filteredData,
        };

        let nozzleComponents = [];

        const compIdField = formInstance?.current?.getComponent("compId");

        // Loop through componentWorking
        componentData.forEach((comp) => {
          const concat = comp?.concatenate?.toUpperCase() || "";
          const compMaster = comp?.compMaster?.toUpperCase() || "";

          if ((concat.includes("NOZ") || compMaster.includes("NOZZLE")) && querydata?.form?.title === "NDC") {
            nozzleComponents.push(comp);
            newFormData = {
              ...newFormData,
              nozzle1: nozzleComponents,
            };


            if (compIdField) {
              const options = nozzleComponents.map((n) => ({
                label: n.compId,
                value: n.compId,
              }));

              options.unshift({
                label: "Add New Nozzle",
                value: "addNewNozzle",
              });

              compIdField.component.data.values = options;
              compIdField.redraw(true);

            }

          }
          newFormData = {
            ...newFormData,
            division: comp.division === "DIV I" ? "DIV 1" : comp.division === "DIV II" ? "DIV 2" : comp.division,
          };

          if (concat.includes("TOP SHELL")) {
            newFormData = {
              ...newFormData,
              vesselIdIn: comp.innerDiameter,
              internalPressurePsi: comp.codeSignPressure,
              internalTempF: comp.codeSignTemperature,
              externalPressurePsi: comp.orgCorAllow,
              externalTempF: comp.codeSignTemperature,
              mdmtPerNameplateOrU1A: comp.mdmTemperature,

            };
          }

          if (concat.includes("BOTTOM SHELL")) {
            newFormData = {
              ...newFormData,
              vesselIdIn1: comp.innerDiameter,
              internalPressurePsi1: comp.codeSignPressure,
              internalTempF1: comp.codeSignTemperature,
              externalPressurePsi1: comp.orgCorAllow,
              externalTempF1: comp.codeSignTemperature,
              mdmtPerNameplateOrU1A1: comp.mdmTemperature,
            };
          }

          if (concat.includes("TOP HEAD")) {
            newFormData = {
              ...newFormData,
              hemi21TorrFlat: comp.headGeom,
              material1: comp.refMaterial,
              efficiencyOrRtMark1: comp.jointEfficiency,
              nominalThicknessIn1: comp.orgThickness,
              minMeasuredThicknessIn1: comp.orgThickness,
              refMaterial1: comp.refMaterial,
            };
            const refMaterial1 = formInstance?.current?.getComponent("refMaterial1");
            if (refMaterial1) {

              const options = equipmentCutData.map((n) => ({
                label: n.material,
                value: n.material,
              }));

              refMaterial1.component.data.values = options;

              refMaterial1.redraw(true);

            }
          }

          if (concat.includes("BOTTOM HEAD")) {
            newFormData = {
              ...newFormData,
              hemi21TorrFlat1: comp.headGeom,
              material2: comp.refMaterial,
              efficiencyOrRtMark2: comp.jointEfficiency,
              nominalThicknessIn2: comp.orgThickness,
              minMeasuredThicknessIn2: comp.orgThickness,
              refMaterial2: comp.refMaterial,

            };
            const refMaterial2 = formInstance?.current?.getComponent("refMaterial2");
            if (refMaterial2) {

              const options = equipmentCutData.map((n) => ({
                label: n.material,
                value: n.material,
              }));

              refMaterial2.component.data.values = options;

              refMaterial2.redraw(true);

            }
          }

          if (concat.includes("-SHELL")) {
            newFormData = {
              ...newFormData,
              pwht: comp.pwht,
              refMaterial: comp.refMaterial,
              jointEfficiency: comp.jointEfficiency,
              orgThickness: comp.orgThickness,
            };
          }
        });

        newFormData = {
          ...newFormData,
          ...querydata?.previousFormSubmission,
        };
        formInstance.current.setSubmission(
          {
            ...formInstance.current.submission,
            data: newFormData,
          },
          { noValidate: true, modified: false }
        );

      }
    }
    if (changed?.component?.key === "compId") {

      const nozzleArray = data.nozzle1 || [];
      let selectedCompId;
      if (nozzleArray.length > 0) {
        selectedCompId = nozzleArray[nozzleArray.length - 1].compId;
      }

      if (!selectedCompId) return;

      let componentData;
      if (eqData) {
        componentData = eqData?.componentWorking || [];
      }
      const selectedNozzle = componentData.find(
        (comp) => comp.compId === selectedCompId
      );

      if (selectedNozzle) {
        let updatedNozzles = [...formInstance.current.submission.data.nozzle1 || []];

        const index = updatedNozzles.findIndex(n => n.compId === selectedCompId);
        if (index !== -1) {
          updatedNozzles[index] = selectedNozzle;
        } else {
          updatedNozzles.push(selectedNozzle);
        }

        formInstance.current.setSubmission(
          {
            ...formInstance.current.submission,
            data: {
              ...formInstance.current.submission.data,
              nozzle1: updatedNozzles,
            },
          },
          { noValidate: true, modified: true }
        );
      }
    }
  };


  const prefillFormFields = (form) => {

    if ((form?._form?.title === "SSDC" || form?._form?.title === "VCDCC" || form?._form?.title === "VCDC-ND" || form?._form?.title === "NDC") && querydata?.previousFormSubmission) {
      const refillData = querydata?.previousFormSubmission;
      console.log("this is refill data", refillData);
      const facility = form.getComponent("facility");
      if (facility) {
        facility.setValue(refillData?.facility, { fromSubmission: true });
      }

      const unit = form.getComponent("unitNumber");
      if (unit) {
        unit.setValue(refillData?.unitNumber, { fromSubmission: true });
      }

      const serialNumber = form.getComponent("serialNumber");
      if (serialNumber) {
        serialNumber.setValue(refillData?.serialNumber, { fromSubmission: true });
      }
      console.log("this is serial number", refillData?.serialNumber);

      const service = form.getComponent("description");
      if (service) {
        service.setValue(refillData?.description, { fromSubmission: true });
      }
      const nationalBoard = form.getComponent("regNumber");
      if (nationalBoard) {
        nationalBoard.setValue(refillData?.regNumber, { fromSubmission: true });
      }
      const qrCnic = form.getComponent("equipmentNumber");
      if (qrCnic) {
        qrCnic.setValue(refillData?.equipmentNumber, { fromSubmission: true });
      }
    }
    const qrCnic = form.getComponent("equipmentNumber");
    if (qrCnic) {
      qrCnic.setValue(querydata?.equipmentNumbers, { fromSubmission: true });
    }
  };

  const handleNextForm = async (nextSubmission) => {
    // setLoading(true);
    const AllStages = querydata?.AllStages;
    const fulldata = {
      ...nextSubmission,
      AllStages,
      previousFormSubmission: submission?.data || formInstance?.current?.submission?.data || {},
    };
    let submissionResponse = null;
    if (nextSubmission.currentStage) {
      submissionResponse = await axiosInstance.get(
        `Inspection/GetSubmissonByStageId/${nextSubmission?.currentStage}`
      );
    }


    if (submissionResponse?.data?.data) {

      setLoading(false);
      navigate("/my-package/form", {
        state: {
          data: fulldata,
          eqData: eqData,
          rerender: true,
          submission: submissionResponse?.data?.data || null,

        },
      });
    } else {
      navigate("/my-package/form", {
        state: {
          data: fulldata,
          eqData: eqData,
          rerender: true,
          // submission: submission || null,
        },
      });
      setLoading(false);
    }

  };
  const hasSubmission = querydata?.isSubmission;


  return (
    <div style={{ height: "100vh", overflowY: "scroll" }}>

      <div className="form-header">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "8px",
          }}
        >
          <button
            onClick={() => navigate("/my-package/pending")}
            className="back-btn"
          >
            <IoMdArrowBack fontSize="24px" />
          </button>
          {/* <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              minWidth: 0,
            }}
          >
            {querydata?.form?.title}
          </h1> */}
        </div>

        <div className="tabs-container">
          {querydata?.AllStages
            ?.sort((a, b) => a.stageLevel - b.stageLevel)?.map((stage, index) => {
              const isSelected = selectedTab === index;
              return (
                <button
                  key={stage.currentStage}
                  onClick={() => {
                    setSelectedTab(index);
                    handleNextForm(stage);
                  }}
                  disabled={!stage.hasSubmissionAccess}
                  className={`tab-btn 
                    ${isSelected ? "active" : ""} 
                       ${!stage.hasSubmissionAccess ? "disabled-btn" : ""}
                              `}
                >
                  {stage?.form?.title}
                </button>
              );
            })}
        </div>
      </div>

      <p>Form ID: {querydata?.form?._id}</p>
      <FormioProvider baseUrl={process.env.REACT_APP_API_URL_LOCAL}>
        {submission &&
          querydata?.mySubmissionStatus == "Submitted" &&
          disableCompponents ? (
          <NewForm
            formInstance={formInstance}
            title={querydata?.form?.name}
            src={`Forms/${querydata?.form?._id}`}
            submission={submission}
            inspectionStageId={querydata?.currentStage}
            submissionId={querydata?.submissionId}
            options={{
              readOnly: true,
              hideSumbit: true,

              hide: {
                submit: true,
                submit1: true,
                approve: true,
              },
              disabled: {
                ...disableCompponents,
              },
            }}
            onFormReady={() => {
              window.__API_BASE__ = process.env.REACT_APP_API_URL_LOCAL;
              window.Job_Site = querydata.jobSiteId;
              window.Eq_Id = querydata?.equipmentNumbers;
              window.Job_FormId = querydata?.form?._id;


            }}
          />
        ) : submission ? (
          disableCompponents && (
            <NewForm
              src={`Forms/${querydata?.form?._id}`}
              submission={submission}
              formInstance={formInstance}
              allStages={querydata?.AllStages}
              eqData={eqData}
              onChange={({ changed, data }, flags, modified) => {
                console.log(data, modified, changed, flags);
                if (changed?.component?.key === "compId" && changed.value === "addNewNozzle") {
                  newNozzleRef.current?.openModal();
                  return;
                }
              }}
              options={{
                disabled: {
                  ...disableCompponents,
                },
                hide: {
                  approve: true,
                  submit1: hasSubmission ? false : true,

                },
              }}
              onFormReady={() => {
                window.__API_BASE__ = process.env.REACT_APP_API_URL_LOCAL;
                window.Job_Site = querydata.jobSiteId;
                window.Eq_Id = querydata?.equipmentNumbers;
                window.Job_FormId = querydata?.form?._id;

              }}
              inspectionStageId={querydata?.currentStage}
              submissionId={querydata?.submissionId}

            />
          )
        ) : (
          disableCompponents && (
            <NewForm
              src={`Forms/${querydata?.form?._id}`}
              formInstance={formInstance}
              inspectionStageId={querydata?.currentStage}
              allStages={querydata?.AllStages}
              eqData={eqData}
              options={{
                disabled: {
                  ...disableCompponents,
                },
                hide: {
                  approve: true,
                  submit1: hasSubmission ? false : true,

                },
                resetAfterSubmit: false,
              }}
              onChange={({ changed, data }, flags, modified) => {
                if (changed?.component?.key === "compId" && changed.value === "addNewNozzle") {
                  newNozzleRef.current?.openModal();
                  return;
                }
                if (changed?.component?.key === "equipmentNumber" || (changed?.component?.key === "nozThickness" && !changed?.value &&
                  data?.nozzle1?.length === 1)) {
                  handleEquipmentChange(
                    { changed, data },
                    modified,
                    formInstance,
                  );
                }
                // submissionRefil(formInstance);

              }}
              onFormReady={(form) => {
                prefillFormFields(form);
                window.__API_BASE__ = process.env.REACT_APP_API_URL_LOCAL;
                window.Job_Site = querydata.jobSiteId;
                window.Eq_Id = querydata?.equipmentNumbers;
                window.Job_FormId = querydata?.form?._id;
              }}
            />
          )
        )}
      </FormioProvider>
      {loading && <Loader />}
      <NewNozzle
        ref={newNozzleRef}
        // newNozzle={newNozzle}
        // setNewNozzle={setNewNozzle}
        formInstance={formInstance}
      />


    </div>
  );
}

export default MyInspectionForm;
